import barsIcon from './bars-solid.svg';
import styles from './Navbar.module.css';

const MobileNavBar = (props) => {
  return (
    <>
      <img className={styles.hamburger_nav} src={barsIcon} alt="no" />
    </>
  );
};

export default MobileNavBar;
